(function () {
  'use strict';

  angular
    .module('eclipseApp.core')
    .directive('moveNextFromElement', function () {
      return {
        restrict: 'A',
        link: function ($scope, element) {
          element.on('input', function (e) {
            if (element.val().length.toString() === element.attr('maxlength')) {
              var $nextElement = element.next();
              if ($nextElement.length) {
                $nextElement[0].focus();
                setTimeout(function () { $nextElement[0].select(); }, 50);
              } else {
                element.parents('form').find(':submit')[0].focus();
              }
            }
          });
        }
      };
    });
})();
